<div
  class="flex flex-col overflow-hidden flex-1"
  [class.has-custom-actions]="!!customActions()"
  [class.has-selection]="isSelectionEnabled()"
  [class.no-actions-table]="userRole() === eUserRolesIds.ReadOnly"
>
  @if (isReady()) {
    <avs-datagrid
      class="main-table flex-1 overflow-hidden"
      (loadMore)="loadMore()"
      (selectionChanged)="selectionChanged.emit($event)"
      (sortChange)="devicesStore.updateSort($event)"
      [alwaysShowTable]="true"
      [columns]="columns"
      [hasMore]="hasMore()"
      [isLoading]="isDataLoading()"
      [resizableColumns]="true"
      [rowHeight]="TYPICAL_COL_HEIGHT"
      [rows]="data()"
      [selectable]="isSelectionEnabled()"
      [selectAll]="!!config().selectAll"
      [selected]="selected() ?? []"
      [sort]="config().sorting ? devicesStore.sort() : null"
      [stickyColumns]="config().stickyColumns"
      [tableId]="tableId()"
      [zoomControls]="config().zoomControls"
    >
      <!-- Number Column -->
      <ng-template
        avsCell="index"
        let-i="index"
      >
        <span class="avs-truncate">{{ i + 1 }}</span>
      </ng-template>

      <!-- Device Name Column -->
      <ng-template
        avsCell="deviceName"
        let-element
      >
        <a
          class="cursor-pointer avs-truncate test-device-name"
          (click)="goToDevice(element)"
          [class.underline]="!config().reportMode"
        >
          {{ element.deviceName }}
        </a>
      </ng-template>

      <!-- Last Reported Column -->
      <ng-template
        avsCell="latestStreamingTimestamp"
        let-element
      >
        <span>{{ element.latestStreamingTimestamp | date: 'M/d/y, h:mm:ss a' }}</span>
      </ng-template>

      <!-- IsDC Column -->
      <ng-template
        avsCell="isDC"
        let-element
      >
        <span avsRestrictedEl>
          @if (element.isDC) {
            <mat-icon fontIcon="check" />
          } @else {
            --
          }
        </span>
      </ng-template>

      <!-- Firmware Column -->
      <ng-template
        avsCell="firmware"
        let-element
      >
        <span class="avs-truncate">{{ element | avsDeviceAttribute: 'firmware' : true : '-' }}</span>
      </ng-template>

      <!-- Mac Address Column -->
      <ng-template
        avsCell="mac address"
        let-element
      >
        <span class="avs-truncate">{{ element | avsDeviceAttribute: 'macAddress' : true : '-' }}</span>
      </ng-template>

      <!-- Building Column -->
      <ng-template
        avsCell="building"
        let-element
      >
        <a
          class="avs-truncate"
          [class.underline]="!config().reportMode"
          [routerLink]="config().reportMode ? null : ['/dashboard', element.buildingId]"
        >
          {{ element.building || '-' }}
        </a>
      </ng-template>

      <!-- Floor Column -->
      <ng-template
        avsCell="floor"
        let-element
      >
        @if (config().reportMode || !element.floorId) {
          <span class="avs-truncate">{{ element?.floor || '-' }}</span>
        } @else {
          <a
            class="avs-truncate underline"
            [routerLink]="['/dashboard', element.buildingId, element.floorId]"
          >
            {{ element?.floor || '-' }}
          </a>
        }
      </ng-template>

      <!-- Room Column -->
      <ng-template
        avsCell="room"
        let-element
      >
        @if (config().reportMode || !element.roomId) {
          <span class="avs-truncate">{{ element?.room || '-' }}</span>
        } @else {
          <a
            class="avs-truncate underline"
            [routerLink]="['/dashboard', element.buildingId, element.floorId, element.roomId]"
          >
            {{ element?.room || '-' }}
          </a>
        }
      </ng-template>

      <!-- Status Column -->
      <ng-template
        avsCell="status"
        let-element
      >
        <avs-device-display-status [device]="element" />
      </ng-template>

      <!-- Device Type Column -->
      <ng-template
        avsCell="deviceType"
        let-element
      >
        <span class="avs-truncate">{{ element.deviceType || '-' }}</span>
      </ng-template>

      <!-- Manufacturer Column -->
      <ng-template
        avsCell="manufacturer"
        let-element
      >
        <span class="avs-truncate">{{ element.manufacturer || '-' }}</span>
      </ng-template>

      <!-- Model Column -->
      <ng-template
        avsCell="model"
        let-element
      >
        <span class="avs-truncate">{{ element.model }}</span>
      </ng-template>

      <!-- Serial Number Column -->
      <ng-template
        avsCell="serialNumber"
        let-element
      >
        <span class="avs-truncate">{{ element | avsDeviceAttribute: 'serialNumber' : true : '-' }}</span>
      </ng-template>

      <!-- IP address Column -->
      <ng-template
        avsCell="ipAddress"
        let-element
      >
        <span class="avs-truncate">{{ element | avsDeviceAttribute: 'ipAddress' : true : '-' }}</span>
      </ng-template>

      <!-- Incident Column -->
      <ng-template
        avsCell="incidents"
        let-element
      >
        @if (element.status === eEntityStatus.Active || element.status === eEntityStatus.Paused) {
          <avs-incident-severity-count
            [incidents]="element.incidents"
            compact
            showZero
          />
        }
      </ng-template>

      <!-- Actions Column -->
      <ng-template
        avsCell="actions"
        let-element
      >
        <div
          class="flex justify-end"
          [showForClientAdmin]="true"
          avsRestrictedEl
        >
          <ng-container *ngTemplateOutlet="customActions() ?? standardActions; context: { $implicit: element }" />
        </div>
      </ng-template>
    </avs-datagrid>

    @if (!devicesStore.entities().length && !isDataLoading()) {
      <avs-no-data-placeholder
        [hasBigPadding]="config().largePlaceholder || false"
        [noDataText]="config().placeholder ?? 'No devices yet'"
        [resultContent]="config().placeholder ? false : filtersApplied()"
      >
        <img
          alt="placeholer_img"
          src="assets/icons/datapoints-placeholder.svg"
        />
      </avs-no-data-placeholder>
    }
  }

  @if (!isReady()) {
    <app-skeleton-table
      [showFilters]="config().filtersSkeleton"
      [showTabs]="config().filtersSkeleton"
    />
  }
</div>

<ng-template
  #standardActions
  let-element
>
  @if (element.status !== eEntityStatus.Archived) {
    <i
      class="action-icon icon-edit"
      [routerLink]="['/devices', 'edit', element.buildingId, element.id]"
      avsRestrictedEl
      matTooltip="Edit Device"
    ></i>
  }

  @if (element.status === eEntityStatus.Paused) {
    <i
      class="icon-play-16 action-icon"
      (click)="resumeDevice(element)"
      [showForClientAdmin]="true"
      avsRestrictedEl
      matTooltip="Resume"
    ></i>
  }

  @if (element.status === eEntityStatus.Active) {
    <i
      class="icon-pause-16 action-icon"
      (click)="pauseDevice(element)"
      [showForClientAdmin]="true"
      avsRestrictedEl
      matTooltip="Pause Device"
    ></i>
  }
  @if (element.status !== eEntityStatus.Archived) {
    <avs-firmware-status
      class="mr-2"
      [config]="{
        deviceId: element.id,
        firmware: element.latestFirmware,
        manufacturerId: element.deviceMakerId,
        version: element.firmware,
      }"
      avsRestrictedEl
    />
  }

  @if (element.status !== eEntityStatus.Archived) {
    <i
      class="icon-add-to-archive action-icon"
      (click)="archiveDevice(element)"
      avsRestrictedEl
      matTooltip="Archive"
    ></i>
  }

  @if (element.status === eEntityStatus.Archived) {
    <i
      class="icon-remove action-icon text-4xl"
      (click)="deleteDevicePermanently(element)"
      avsRestrictedEl
      matTooltip="Delete Device"
    ></i>
  }

  @if (element.status === eEntityStatus.Archived && element.spacePath?.at(-1)?.status !== eEntityStatus.Archived) {
    <i
      class="icon-restore action-icon"
      (click)="restoreDevice(element)"
      avsRestrictedEl
      matTooltip="Restore"
    ></i>
  }
</ng-template>
